import { useEffect, useState } from 'react';

// Preferências POR APARELHO (localStorage): cada usuário ajusta a experiência do
// jeito que gosta — tema, como quer ser avisado, som, volume e o comportamento
// do Enter. Aplicadas ao vivo via evento 'fio-prefs' (todas as telas reagem).
const KEY = 'fio_prefs';

export const DEFAULTS = {
  tema: 'escuro',            // escuro | claro
  modeloNotif: 'som_vibra',  // som_vibra | so_som | so_vibra | silencioso
  som: 'suave',              // suave | alerta | discreto
  volume: 60,                // 0-100
  enterEnvia: true,          // true = Enter envia (Shift+Enter quebra linha); false = Enter quebra linha
  filtroStatus: '',          // filtro de status padrão ao abrir: '' | aberta | em_atendimento | encerrada
  filtroFila: '',            // filtro de fila padrão ao abrir: '' (todas) | __pendente__ | <id da fila>
};

export const FILTRO_STATUS_OPCOES = [
  { valor: '', label: 'Todas' },
  { valor: 'aberta', label: 'Aberta' },
  { valor: 'em_atendimento', label: 'Em atendimento' },
  { valor: 'encerrada', label: 'Encerrada' },
];

export const SOM_OPCOES = [
  { valor: 'suave', label: 'Suave' },
  { valor: 'alerta', label: 'Alerta' },
  { valor: 'discreto', label: 'Discreto' },
];

export const MODELO_OPCOES = [
  { valor: 'som_vibra', label: 'Som e vibração' },
  { valor: 'so_som', label: 'Só som' },
  { valor: 'so_vibra', label: 'Só vibração' },
  { valor: 'silencioso', label: 'Silencioso' },
];

export function getPrefs() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : { ...DEFAULTS };
  } catch (e) {
    return { ...DEFAULTS };
  }
}

export function aplicarTema(tema) {
  document.documentElement.setAttribute('data-theme', tema === 'claro' ? 'light' : 'dark');
}

export function setPrefs(patch) {
  const novo = { ...getPrefs(), ...patch };
  try { localStorage.setItem(KEY, JSON.stringify(novo)); } catch (e) { /* ignore */ }
  if (patch.tema !== undefined) aplicarTema(novo.tema);
  window.dispatchEvent(new CustomEvent('fio-prefs'));
  return novo;
}

// Chamada uma vez no boot pra aplicar o tema salvo antes da UI aparecer.
export function initPrefs() {
  aplicarTema(getPrefs().tema);
}

// Hook: retorna [prefs, setPrefs] e re-renderiza quando qualquer tela muda algo.
export function usePrefs() {
  const [prefs, setLocal] = useState(getPrefs);
  useEffect(() => {
    const h = () => setLocal(getPrefs());
    window.addEventListener('fio-prefs', h);
    return () => window.removeEventListener('fio-prefs', h);
  }, []);
  return [prefs, setPrefs];
}

// Config de som derivada das preferências, no formato que playNotificationSound espera.
export function somConfigDe(prefs) {
  const comSom = prefs.modeloNotif === 'som_vibra' || prefs.modeloNotif === 'so_som';
  return { ativo: comSom, tipo: prefs.som, volume: prefs.volume };
}

export function deveVibrar(prefs) {
  return prefs.modeloNotif === 'som_vibra' || prefs.modeloNotif === 'so_vibra';
}
